"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _api = require("../api/api");
var _elementUi = require("element-ui");
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _default = exports.default = {
  data: function data() {
    return {
      showWhiteImg: false,
      //是否显示白色的图片
      // 导航栏配置
      configNav: [{
        name: '首页',
        path: '/home'
      }, {
        name: '千城联盟',
        path: '/wllm'
      }, {
        name: '物流解决方案',
        path: '/logistics'
      }, {
        name: '商务解决方案',
        path: '/bussiness'
      }, {
        name: '软件解决方案',
        path: '/software',
        subItems: [{
          link: {
            path: '/software'
          },
          text: '镖神管家'
        }, {
          link: {
            path: '/BMS'
          },
          text: 'BMS'
        }]
      }, {
        name: '化工资讯',
        path: '/goods',
        subItems: [{
          link: {
            path: '/goods'
          },
          text: '交易大厅'
        }, {
          link: {
            path: '/specialVehicle'
          },
          text: '镖局专车'
        }, {
          link: {
            path: '/chemicalMall'
          },
          text: '化工商城'
        }, {
          link: {
            path: '/waybill'
          },
          text: '电子运单'
        }, {
          link: {
            path: '/msdsList'
          },
          text: 'MSDS'
        }, {
          link: {
            path: '/newslist',
            query: {
              isSearch: false,
              searchVal: '',
              isDetail: false
            },
            params: {
              isSearch: false
            }
          },
          text: '危化头条'
        }, {
          link: {
            path: '/cooperationMall/zpList'
          },
          text: '危化商铺'
        }]
      }, {
        name: '关于我们',
        path: '/aboutus'
      }],
      currentNavItem: null,
      // 当前移入的导航栏
      navConfig: {
        bgColor: '#fff',
        textColor: '#212121'
      },
      // 导航栏颜色配置

      activeIndex: '1',
      //登录状态菜单
      dialogTgVisible: false,
      //推广弹窗的显示隐藏

      tgImgs: [require("../assets/static/img/qrCode_01.jpg"), require("../assets/static/img/qrCode_02.jpg"), require("../assets/static/img/qrCode_03.jpg"), require("../assets/static/img/qrCode_04.jpg"), require("../assets/static/img/qrCode_05.jpg")],
      qrCodetg: '',
      //推广码
      tgUrl: '' //推广链接
    };
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route: {
      handler: function handler(val, oldVal) {
        if (val.path == '/home') {
          this.showWhiteImg = true;
          var bgImg = "url('https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%AF%BC%E8%88%AAbg%402x.png')";
          var gradient = "transparent";
          // 合并赋值
          this.navConfig.bgColor = "".concat(bgImg, " center center / 1920px 100% no-repeat, ").concat(gradient);
          this.navConfig.textColor = '#fff';
        } else if (val.path == '/wllm') {
          this.showWhiteImg = false;
          // 这里的顺序很重要：图片在前面（上层），渐变在后面（下层）
          var _bgImg = "url('https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%AF%BC%E8%88%AAbg%402x.png')";
          var _gradient = "#000A39";
          // 合并赋值
          this.navConfig.bgColor = "".concat(_bgImg, " center center / 1920px 100% no-repeat, ").concat(_gradient);
          this.navConfig.textColor = '#fff';
        } else if (val.path == '/software') {
          this.showWhiteImg = false;
          // 这里的顺序很重要：图片在前面（上层），渐变在后面（下层）
          var _bgImg2 = "url('https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%AF%BC%E8%88%AAbg%402x.png')";
          var _gradient2 = "linear-gradient(to bottom, rgb(0,2,61), rgb(0,18,144))";
          // 合并赋值
          this.navConfig.bgColor = "".concat(_bgImg2, " center center / 1920px 100% no-repeat, ").concat(_gradient2);
          this.navConfig.textColor = '#fff';
        } else if (val.path == '/BMS') {
          this.showWhiteImg = false;
          // 这里的顺序很重要：图片在前面（上层），渐变在后面（下层）
          var _bgImg3 = "url('https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%AF%BC%E8%88%AAbg%402x.png')";
          var _gradient3 = "#000A39";
          // 合并赋值
          this.navConfig.bgColor = "".concat(_bgImg3, " center center / 1920px 100% no-repeat, ").concat(_gradient3);
          this.navConfig.textColor = '#fff';
        } else if (val.path == '/logistics') {
          this.showWhiteImg = false;
          var _bgImg4 = "url('https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%AF%BC%E8%88%AAbg%402x.png')";
          var _gradient4 = "#000A39";
          this.navConfig.bgColor = "".concat(_bgImg4, " center center / 1920px 100% no-repeat, ").concat(_gradient4);
          this.navConfig.textColor = '#fff';
        } else if (val.path == '/bussiness') {
          this.showWhiteImg = false;
          var _bgImg5 = "url('https://whbj-yellowpage.oss-cn-shenzhen.aliyuncs.com/H5_vue3/%E6%96%B0%E5%AE%98%E7%BD%91/%E9%A6%96%E9%A1%B5/%E5%AF%BC%E8%88%AAbg%402x.png')";
          var _gradient5 = "#03123B";
          this.navConfig.bgColor = "".concat(_bgImg5, " center center / 1920px 100% no-repeat, ").concat(_gradient5);
          this.navConfig.textColor = '#fff';
        } else {
          this.showWhiteImg = false;
          this.navConfig.bgColor = '#fff';
          this.navConfig.textColor = '#212121';
        }
        // this.showWhiteImg = true
        // this.navConfig.bgColor = 'transparent'
        // this.navConfig.textColor = '#fff'
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    // 推广弹窗随机背景
    backgroundImage: function backgroundImage() {
      var randIndex = Math.floor(Math.random() * this.tgImgs.length);
      return {
        backgroundImage: "url(".concat(this.tgImgs[randIndex], ")")
      };
    }
  },
  methods: {
    // 鼠标进入极其简化版
    mouseenter: function mouseenter(item) {
      this.currentNavItem = item;
    },
    // 鼠标离开极其简化版
    mouseleave: function mouseleave() {
      this.currentNavItem = null;
    },
    toPage: function toPage(path) {
      if (this.$route.fullPath == path) return;
      var loadInstance = _elementUi.Loading.service({
        background: 'rgba(0, 0, 0, 0.5)'
      });
      setTimeout(function () {
        loadInstance.close();
      }, 400);
      this.$router.push({
        path: path
      });
      // 路由跳转后收起下拉
      this.currentNavItem = null;
    },
    toItemPage: function toItemPage(link) {
      var loadInstance = _elementUi.Loading.service({
        background: 'rgba(0, 0, 0, 0.5)'
      });
      setTimeout(function () {
        loadInstance.close();
      }, 400);
      if (link.path.indexOf('https:') != -1) {
        return window.open(link.path, '_blank');
      }
      this.$router.push({
        path: link.path,
        query: link.query ? link.query : {},
        params: link.params ? link.params : {}
      });
      // 路由跳转后收起下拉
      this.currentNavItem = null;
    },
    // 我要推广的点击事情
    toTg: function () {
      var _toTg = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, param, _yield$apiGetTgData, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this;
              param = {
                userId: (0, _cookie.getCookie)('user') ? JSON.parse((0, _cookie.getCookie)('user')).userId : ''
              };
              _context.next = 4;
              return (0, _api.apiGetTgData)(param);
            case 4:
              _yield$apiGetTgData = _context.sent;
              data = _yield$apiGetTgData.data;
              if (data.proRst) {
                that.qrCodetg = data.userImg; //推广码
                that.tgUrl = data.userUrl; //推广链接
              } else {
                this.$message({
                  message: data.proMsg,
                  type: 'error'
                });
              }
              that.dialogTgVisible = true;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function toTg() {
        return _toTg.apply(this, arguments);
      }
      return toTg;
    }(),
    // 登录的点击事件
    clickToLogin: function clickToLogin() {
      this.tabName = 'first';
      this.$root.loginscene = 'HOME_PAGE'; //注册登录场景
      this.$root.dialogFormVisible = true;
    },
    // 退出登录
    toLogoff: function toLogoff() {
      var that = this;
      (0, _cookie.delCookie)('user');
      (0, _cookie.delCookie)('token');
      that.$root.token = '';
      that.$root.isLogin = false;
      if (that.$route.name == 'pubcars' || that.$route.name == 'pubgoods') {
        that.$root.dialogFormVisible = true;
      }
    }
  }
};